export default "__VITE_ASSET__DUrYSRL5__"